import { Component } from '@angular/core';
import { NavParams, ViewController, LoadingController } from 'ionic-angular';
import { AppState } from '../../config/state';
import { ReserveProvider } from '../../providers/reserve/reserve';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';

import moment from 'moment';

/**
 * Generated class for the CoReserveReservationsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-reserve-reservations',
  templateUrl: 'co-reserve-reservations.html'
})
export class CoReserveReservationsComponent {

  patron: any;
  reservations: Array<Object>;
  earlySignInTime: number;
  timeFormat: string;
  showBookingDate: boolean;

  constructor(private navParams: NavParams, private viewCtrl: ViewController, private state: AppState, private clientDetails: ClientDetailsProvider, private reserveProvider: ReserveProvider, private toast: ToastAlertsProvider, private loadingController: LoadingController) {
    this.patron = this.navParams.get('patron');
    this.timeFormat = this.state.internationalTime ? 'HH:mm' : 'h:mm a';
    this.showBookingDate = this.state.reserveSignInBookingDate;
  }

  async ngOnInit() {
    let loading = this.loadingController.create({content: 'Getting your reservations'});
    loading.present();
    this.earlySignInTime = await this.clientDetails.load().then( res => res.settings.rooms_early_signin_minutes );
    await this.reserveProvider.getReservations(moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')).then( res => {
      this.reservations = res.filter( (reservation) => {
        if(reservation.libraryCard !== this.patron.barcode) return false;
        if(moment(reservation.endTime).isBefore(moment())) return false;
        return true;
      })
      .map( (reservation) => {
        switch(reservation['noShow']) {
          case 0:
            reservation['signedIn'] = false;
            reservation['signedOut'] = false;
            break;
          case 1:
          case 3:
            reservation['signedIn'] = false;
            reservation['signedOut'] = true;
            break;
          case 2:
            reservation['signedIn'] = true;
            reservation['signedOut'] = false;
        }
        const signInAt = moment(reservation.startTime).subtract(this.earlySignInTime, 'minutes');
        reservation['signInAt'] = signInAt.format(this.timeFormat);
        reservation['canSignIn'] = !reservation['signedIn'] && !reservation['signedOut'] && moment().isAfter(signInAt) && (reservation.status === 'approved');
        return reservation;
      });
    });
    loading.dismiss();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  signIn(roomId: number) {
    let loading = this.loadingController.create({content: 'Signing In'});
    loading.present();
    this.reserveProvider.signInForReservation(this.patron.barcode, this.patron.pin, roomId).then( res => {
      console.log(res);
      if(res && res.signIn && res.signIn.success) {
        loading.dismiss();
        this.toast.showAlert('Signed In', 'You have signed in for your reservation', 'success', 10000);
        this.dismiss();
      }
      else if(res && res.signIn && res.signIn.message) {
        loading.dismiss();
        this.toast.showAlert('Error', res.signIn.message, 'warning', 10000);
      }
      else {
        loading.dismiss();
        this.toast.showAlert('Error', 'There was a problem signing in for your reservation', 'warning', 10000);
      }
    }).catch( () => {
      loading.dismiss();
      this.toast.showAlert('Error', 'There was a problem signing in for your reservation', 'warning', 10000);
    });
  }

  endReservation(roomId: number) {
    let loading = this.loadingController.create({content: 'Ending Reservation'});
    loading.present();
    this.reserveProvider.patronEndReservation(this.patron.barcode, this.patron.pin, roomId).then( res => {
      if(res && res.signOut && res.signOut.success) {
        loading.dismiss();
        this.toast.showAlert('Reservation Ended', 'You have ended your reservation early', 'success', 10000);
        this.dismiss();
      }
      else if(res && res.signOut && res.signOut.message) {
        loading.dismiss();
        this.toast.showAlert('Error', res.message);
      }
      else {
        loading.dismiss();
        this.toast.showAlert('Error', 'There was a problem ending your reservation');
      }
    }).catch( () => {
      loading.dismiss();
      this.toast.showAlert('Error', 'There was a problem ending your reservation');
    });
  }

}



// WEBPACK FOOTER //
// ./src/components/co-reserve-reservations/co-reserve-reservations.ts